import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesTeamsArchivedRoute extends Route {
  @service store;

  model() {
    return this.modelFor('settings.teams').teams.archived;
  }
}

export default instrumentRoutePerformance(ResourcesTeamsArchivedRoute);
